import { instructionDatesBetween } from "@examspark/common/dist/utils/coursePlanner";
import { AcademicCalendar, GradingPeriod, UnitPlan } from "@examspark/types";

export const calculateGradingPeriods = (
  units: UnitPlan[] | null | undefined,
  calendar: AcademicCalendar | null | undefined,
): GradingPeriod[] | null | undefined => {
  if (!units || !calendar) return null;

  return calendar.gradingPeriods?.map((period) => {
    const gradingPeriodDates = instructionDatesBetween(
      calendar,
      period.startAt,
      period.endAt,
    );

    return {
      ...period,
      length: gradingPeriodDates.length,
      units: units?.filter((unitPlan) =>
        unitPlan.dates?.some((date) => gradingPeriodDates.includes(date)),
      ),
    };
  });
};
